export default __webpack_public_path__ + "static/media/man.34f9fb62.jpg";